<template>
  <div class="reader-list">
    <ListHeader class="default-edit-header" :showVipMessage="false" :listTitle="`${goodsObj.worksName}>读者列表`"></ListHeader>
    <div class="back" @click="goBack"><img src="@imgs/back-icon.png" />返回鉴权阅读管理</div>
    <list-frame class="list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
      <template v-slot:listContent>
        <div class="list-content">
          <div class="table-head">
            <div class="search">
              <div class="search-condition">
                <span>用户名：</span>&nbsp; <el-input v-model="userName" size="mini"></el-input>&nbsp;&nbsp;
                <span>授权方式：</span>
                <el-select v-model="authMethod" size="mini">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="购买" :value="0"></el-option>
                  <el-option label="后台添加" :value="1"></el-option></el-select
                >&nbsp;&nbsp;
                <span>授权状态：</span>
                <el-select v-model="authStatus" size="mini"
                  ><el-option label="全部" value=""></el-option>
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="已到期" :value="2"></el-option>
                  <el-option label="停用" :value="0"></el-option></el-select
                >&nbsp;&nbsp;
              </div>
              <div class="search-btn">
                <el-button type="primary" @click="getList(true)">查询</el-button>
                <el-button class="reset" @click="reset">重置</el-button>
              </div>
            </div>
            <div class="option-button">
              <el-button type="primary" @click="openDialog">添加白名单</el-button>
              <a :href="downloadHref" style="font-size: 16px;color: #3a3a3a;margin-left: 10px;text-decoration: none">导出读者列表</a>
            </div>
          </div>
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="subscriber" label="用户名" min-width="100"> </el-table-column>
            <el-table-column prop="authMethod" label="授权方式" min-width="50"> </el-table-column>
            <el-table-column prop="worksType" label="授权内容" min-width="100"> </el-table-column>
            <el-table-column prop="authStatusText" label="授权状态" min-width="50"> </el-table-column>
            <el-table-column prop="createTime" label="起始时间" min-width="100"> </el-table-column>
            <el-table-column prop="endTime" label="终止时间" min-width="100"> </el-table-column>
            <el-table-column label="操作" min-width="150">
              <template v-slot:default="scope">
                <div class="option-button" :class="{ 'no-click': scope.row.authStatus === 2 }" @click="setSubscribeStatus(scope.row)">{{ scope.row.authStatus === 0 ? '恢复授权' : '停用授权' }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </list-frame>
    <subscribe-add-dialog ref="subscribeDialog" :goods-obj="goodsObj" @savedData="getList"></subscribe-add-dialog>
  </div>
</template>

<script>
import chargeManager from '../../../api/chargeManager'
import ListHeader from '@components/list/listHeader.vue'
import ListFrame from '@components/list/listFrame.vue'
import moment from 'moment'
import SubscribeAddDialog from './SubscribeAddDialog.vue'

export default {
  name: 'ReaderList',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      userName: '',
      authStatus: '',
      authMethod: ''
    }
  },
  computed: {
    downloadHref() {
      return `/ebook/cloudReadSubscribe/exportReaderData?worksId=${this.goodsObj.worksId}&worksType=${this.goodsObj.worksType}&userName=${this.userName}&authMethod=${this.authMethod}&authStatus=${this.authStatus}`
    }
  },
  components: {
    SubscribeAddDialog,
    ListFrame,
    ListHeader
  },
  props: {
    currentModule: String,
    goodsObj: Object
  },
  watch: {},
  methods: {
    setHeaderCellStyle(options) {
      return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
    },
    setCellStyle(options) {
      return 'text-align: center'
    },
    goBack() {
      this.$emit('goBack')
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getList()
    },
    reset() {
      this.userName = ''
      this.authMethod = ''
      this.authStatus = ''
      this.currentPageNo = 1
      this.getList()
    },
    openDialog() {
      if ((!this.goodsObj.period && this.goodsObj.period !== 0) || (this.goodsObj.secret !== 1 && !this.goodsObj.price)) {
        this.$alert(`请完成读者${this.goodsObj.secret === 1 ? '鉴权' : '付费'}设置后添加`)
        return
      }
      this.$refs.subscribeDialog.dialogVisible = true
    },
    getList(isSearch) {
      if (isSearch) {
        this.currentPageNo = 1
      }
      let _this = this
      chargeManager
        .findReaderByPage({
          worksId: this.goodsObj.worksId,
          worksType: this.goodsObj.worksType,
          pageNo: this.currentPageNo,
          pageSize: 10,
          userName: this.userName,
          authMethod: this.authMethod,
          authStatus: this.authStatus
        })
        .then((res) => {
          if (res.data && res.data.data) {
            let data = res.data.data.page
            if (data.result.length) {
              _this.tableData = data.result.map((item) => {
                return {
                  ...item,
                  createTime: item.createTime ? moment(item.createTime).format('YYYY/MM/DD HH:mm:ss') : '',
                  endTime: item.endTime ? moment(item.endTime).format('YYYY/MM/DD HH:mm:ss') : '永久',
                  authMethod: item.authMethod === 0 ? '购买' : item.authMethod === 1 ? '后台添加' : '',
                  authStatusText: item.authStatus === 0 ? '停用' : item.authStatus === 1 ? '正常' : '已到期',
                  worksType: _this.getWorkType(item.worksType)
                }
              })
            } else {
              _this.tableData = []
            }
            _this.totalPages = data.totalPages
            _this.totalCount = data.totalCount
          } else {
            _this.tableData = []
            this.$message({
              message: '获取列表失败',
              type: 'error'
            })
          }
        })
    },
    setSubscribeStatus(item) {
      if (item.authStatus === 2) {
        return
      }
      const param = {
        id: item.id,
        authStatus: item.authStatus === 0 ? 1 : 0
      }
      chargeManager.setSubscribeStatus(param).then((res) => {
        if (res.data.status === 0) {
          this.getList()
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    getWorkType(type) {
      switch (type) {
        case 'cloud_read_ebook_article':
          return '文章 '
        case 'cloud_read_album':
          return '专辑'
        case 'cloud_read_baozhi':
          return '报纸'
        default:
          return '书刊'
      }
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.reader-list {
  .back {
    font-size: 16px;
    line-height: 26.06px;
    color: #df5813;
    position: absolute;
    right: 30px;
    top: 8px;
    cursor: pointer;
    img {
      width: 16px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .search-btn {
    .el-button {
      width: 83px;
      height: 33px;
      font-size: 16px;
      line-height: 33px;
      padding: 0;
      &.reset {
        background-color: #999999;
        color: #fff;
      }
    }
  }
  .table-head {
    .search {
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      .search-condition {
        font-size: 16px;
        .el-input {
          width: 150px;
        }
        .el-select {
          width: 150px;
        }
      }
    }
    .el-button {
      font-weight: 400;
      font-size: 16px;
    }
    .option-button {
      margin-bottom: 20px;
    }
  }
  .el-table {
    .option-button {
      cursor: pointer;
      color: #df5813;
      &.no-click {
        cursor: not-allowed;
        color: #999999;
      }
    }
  }
}
</style>
